import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validador que permite valores numéricos con formato (ej: 1.000.000) y evalúa min y max
 * @param min Mínimo permitido
 * @param max Máximo permitido
 */
export function formattedNumberRangeValidator(
  min: number,
  max: number
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const rawValue = control.value;

    // Remover lo que no sea número
    const numericValue = Number(String(rawValue).replace(/\D/g, ''));

    if (isNaN(numericValue)) {
      return { notANumber: true };
    }

    if (numericValue < min) {
      return { min: { requiredMin: min, actual: numericValue } };
    }

    if (numericValue > max) {
      return { max: { requiredMax: max, actual: numericValue } };
    }

    return null;
  };
}
